/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Hook for bulk operation progress tracking
 */

"use client";

import { useState } from "react";
import type { BulkProgressState } from "./types";

/**
 * Hook for managing bulk operation progress state
 */
export function useBulkProgress() {
  // Bulk operation progress state
  const [bulkProgress, setBulkProgress] = useState<BulkProgressState>({
    operationId: null,
    mode: null,
    status: "pending",
    completed: 0,
    total: 0,
    failed: 0,
    failures: [],
    startedAt: null,
    completedAt: null,
    canPause: false,
    canCancel: false,
    percentage: 0,
    estimatedTimeRemaining: null,
  });

  const isOperationInProgress =
    bulkProgress.status === "running" || bulkProgress.status === "paused";

  return {
    bulkProgress,
    setBulkProgress,
    isOperationInProgress,
  };
}
